<template>
  <v-row class="px-md-1 py-md-0">
    <v-col md="6" cols="12" class="py-md-0">
      <v-card>
        <v-card-title class="subtitle-1">Información del usuario</v-card-title>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="email"
                  placeholder="Email"
                  disabled
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="name" placeholder="Name"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-select
                  v-model="timezone"
                  :items="timezones"
                  label="Zona Horaria"
                ></v-select>
              </v-col>
            </v-row>
            <!-- <v-row>
                <v-col cols="12">
                  <v-switch v-model="darkTheme" label="Dark"></v-switch>
                </v-col>
              </v-row>-->
            <v-row>
              <v-col cols="12">
                <v-btn color="primary" class="text-capitalize">
                  <v-icon size="20" class="mr-1">mdi-content-save</v-icon>Guardar
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-col>
    <v-col md="6" cols="12" class="py-md-0">
      <v-card>
        <v-card-title class="subtitle-1">Conexiones</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-btn
                color="#1DA1F2"
                @click="connectTwitter"
                class="white--text"
                block
                :disabled="!!twitterOauth"
              >
                <v-icon>mdi-twitter</v-icon>
                Twitter
              </v-btn>
            </v-col>
            <v-col cols="2" offset="4" class="d-flex justify-end">
              <v-btn
                v-if="twitterOauth"
                color="red lighten-2"
                @click="deleteTwitter"
                icon
                dark
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TIME_ZONES } from "@/commons/constants.js";

export default {
  data() {
    return {
      email: "",
      name: "",
      timezone: "America/Bogota",
      darkTheme: false,
      oauths: [],
    };
  },
  props: {
    copraUrl: { type: String, default: process.env.VUE_APP_COPRA_SERVER_URL },
    timezones: { type: Array, default: () => TIME_ZONES },
  },
  mounted() {
    this.loadProfile();
  },
  methods: {
    loadProfile() {
      this.$http.get("/api/my-account").then((response) => {
        console.log(response.data);
        this.email = response.data.user.email;
        this.name = response.data.user.name;
        this.oauths = response.data.oauths;
      });
    },
    showAuthWindow({ windowName, path, callback }) {
      if (window) {
        const windowOptions = "location=0,status=0,width=800,height=400";
        this._oauthWindow = window.open(path, windowName, windowOptions);
        this._oauthInterval = window.setInterval(() => {
          if (this._oauthWindow.closed) {
            window.clearInterval(this._oauthInterval);
            if (callback) {
              callback();
            }
          }
        }, 1000);
      }
    },
    connectTwitter() {
      this.$http.get("/api/oauth/twitter").then((response) => {
        let redirect = response.data.redirect;
        console.log("redirect", redirect);
        this.showAuthWindow({
          windowName: "Connectar con  Twitter",
          path: redirect,
          callback: () => this.loadProfile(),
        });
      });
    },
    async deleteTwitter() {
      const res = await this.$confirm(
        ` <h1 class="subtitle-1">Estas seguro que quieres eliminar la conexoón con Twitter?</h1>`,
        {
          buttonTrueText: "Eliminar",
          buttonFalseText: "Cerrar",
          buttonTrueColor: "red lighten-2",
          color: "primary",
          icon: "delete",
          title: "Eliminar Conexión",
          width: 600,
        }
      );
      if (res) {
        this.$http.delete("/api/oauth/twitter").then((response) => {
          console.log(response);
          this.loadProfile();
          this.$eventBus.$emit(
            "showNotification",
            "Conexión a Twitter eliminada satisfactoriamente",
            "success"
          );
        });
      }
    },
  },
  computed: {
    twitterOauth() {
      if (this.oauths) {
        return this.oauths.filter((entry) => {
          if (entry.serviceName == "twitter") {
            return entry;
          }
        })[0];
      }
      return false;
    },
  },
};
</script>

<style>
</style>